
export const SEARCH_PLACEHOLDER = `Поиск мода...`
